module.exports = __webpack_public_path__ + "sg.svg?814c6d6547960991430a1c71871597ed";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/sg.svg
// module id = 1604
// module chunks = 0